export default {
    // Table config settings for column viewing
    state: {
        nav_collapsed: false,
        
    }

}






// WEBPACK FOOTER //
// ./src/store/Interface.js